import React, { useEffect } from "react";
import {
  StyleSheet,
  View,
  Text,
  Platform,
  ActivityIndicator,
  Dimensions,
} from "react-native";
import { NavigationContainer } from "@react-navigation/native";
import { useFonts } from "expo-font";

// Components
import StackNavigator from "./src/navigators/StackNavigator";
import BottomSheet from "./src/components/common/BottomSheet/BottomSheet";

// Data
import { Provider, useDispatch } from "react-redux";
import store from "./src/redux";

// Styles
import { Colors } from "./src/styles";
import { loadData, setUsername } from "./src/redux/mainSlice";
import Stories from "./src/components/stories/Stories";

const App = () => {
  //#region Load data
  const dispatch = useDispatch();
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlParams.entries()) as {
      username: string | undefined;
      dataId: string | undefined;
    };

    if (params.dataId) dispatch(loadData(params.dataId));
    if (params.username) dispatch(setUsername(params.username));
  }, []);
  //#endregion

  //#region Load fonts
  let [fontsLoaded] = useFonts({
    Basker: require("./src/assets/fonts/Baskervville-Italic.ttf"),
    "Stabil-Bold": require("./src/assets/fonts/StabilGrotesk-Bold.otf"),
    "Stabil-Medium": require("./src/assets/fonts/StabilGrotesk-Medium.otf"),
    "Stabil-Regular": require("./src/assets/fonts/StabilGrotesk-Regular.otf"),
  });

  if (!fontsLoaded) {
    return (
      <View>
        <ActivityIndicator />
        <Text>Loading fonts</Text>
      </View>
    );
  }
  //#endregion

  return (
    <View style={styles.container}>
      <View
        style={[
          styles.device,
          Platform.OS === "web" &&
            Dimensions.get("window").width > 480 &&
            styles.deviceFrame,
        ]}
      >
        <NavigationContainer theme={{ colors: { background: Colors.plum900 } }}>
          <StackNavigator />
          <BottomSheet />
          <Stories />
        </NavigationContainer>
      </View>
    </View>
  );
};

const AppWrapper = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

export default AppWrapper;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "black",
  },
  deviceFrame: {
    flex: 1,
    width: "100%",
    maxWidth: 350,
    maxHeight: 700,
    borderRadius: 25,
    margin: 20,
    overflow: "hidden",
    borderWidth: 2,
    borderColor: "rgba(255,255,255,0.5)",
  },
  device: {
    flex: 1,
    width: "100%",
    paddingTop: Platform.OS === "web" ? 0 : 30, //Status bar height
  },
});
